import React from "react";
import logo from "../../images/logo.png";
import goldSilverlogo from "../../images/gold-silver.png";
import { useSelector } from "react-redux";
import "../../components/header/header.css";
import { Link, useLocation } from "react-router-dom";
import { androidUrl, iosUrl, menuTitleArr } from "../../config";
import AndroidImg from '../../images/android.png'
import IosImage from '../../images/ios.png'

export default function Header() {
  const clientData = useSelector((state) => state.clientDetails)[0];
  let location = useLocation().pathname;
  let currentPathName =
    location?.length > 1 ? location?.split("/")[1] : location?.split("/")[0];

  return (
    <>
      <header>
        <div className="container-fluid">
          <div className="row align-items-center m-0">
            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12">
              <div className="header-logo text-center">
                <img src={logo} alt="logo" className="white-bg" />
              </div>
            </div>

            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 ps-0">
              <div className="company-name">
                <h1 className="gradiant-text">
                  Titli Jewellers Pvt Ltd
                </h1>
              </div>
            </div>

            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12">
              <div className="text-center">
                <img src={goldSilverlogo} alt="logo" className="img-fluid header-right-img" />
              </div>
            </div>

          </div>
        </div>
      </header>
      {!!clientData?.marqueeTop && <div className="header-top-marquee">
        <marquee className="marquee2">{clientData?.marqueeTop}</marquee>
      </div>}


    </>
  );
}
